<template>
	<div class="page-container">
		<head-top head-title="提现" goBack="true"></head-top>

		<div class="withdraw-page">

			<div class="balance-card">
				<div class="balance-settings flex_d">
					<div style="margin-right:10px">账户信息</div>
					<van-icon name="edit" @click="goEdit" />
				</div>
				<div class="balance-cell flex_a">
					<div class="balance-label">真实姓名：</div>
					<div class="balance-value">{{ account.realName || '-' }}</div>
				</div>

				<div class="balance-cell flex_a">
					<div class="balance-label">支付宝账号：</div>
					<div class="balance-value">{{ account.alipayAccount || '-' }}</div>
				</div>
			</div>

			<div class="section-title">提现金额</div>
			<div class="amount-card bg_a">
				<div class="amount-input-box flex_a">
					<div class="amount-prefix">$</div>
					<input class="amount-input" name="amount" v-model="amount" placeholder="请输入提现金额" />
				</div>

				<div class="amount-tips">
					<span>当前账户可提现余额 <span class="amount-money"> ${{ balance }} </span> ，</span>
					<span class="amount-all" @click="setAmount(balance)">全部提现</span>
				</div>
			</div>

			<div class="withdraw-btn" @click="handleWithdraw">申请提现</div>
			<div class="withdraw-record flex_d">
				<div @click="goRecords">提现记录</div>
			</div>

			<div class="section-title">提现规则</div>
			<div class="rules-card">
				<div>1.每月22日到月底打款,每次最少提现5美元</div>
				<div>2.提现按付款当天(非提现当天)实时汇率计算并收取2%的手续费</div>
			</div>


			<van-popup v-model="showEditModal" position="center" round :close-on-click-overlay="false" close-on-popstate
				:style="{ width: '90%' }">
				<div class="edit-panel bg_a">
					<div class="edit-header flex_c">
						<div class="edit-title">提现账户信息</div>
						<van-icon name="cross" class="edit-close" @click="closeEditModal" />
					</div>

					<div class="edit-body">
						<div class="edit-field">
							<div class="edit-label">真实姓名：</div>
							<input class="edit-input" v-model="formData.name" name="realname" placeholder="请输入真实姓名" />
						</div>
						<div class="edit-field">
							<div class="edit-label">支付宝账号：</div>
							<input class="edit-input" v-model="formData.account" name="withdrawAccount" placeholder="请输入支付宝账号" />
						</div>
					</div>

					<div class="edit-actions">
						<div class="edit-submit" @click="confirmEdit">确定</div>
					</div>
				</div>
			</van-popup>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		getLoginMember,
		getMineData,
		getWithdrawInfo,
		saveWithdrawAccount,
		submitWithdrawApply
	} from '@/apis/api.js'

	export default {
		name: 'Withdraw',
		components: {
			headTop: headTop
		},
		data() {
			return {
				balance: '0.00',
				account: {},
				amount: '',
				showEditModal: false,
				formData: {
					name: '',
					account: ''
				}
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				if (!getLoginMember()) {
					this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
					return
				}
				this.$toast.loading({ message: '加载中...', duration: 0 })
				this.getMineInfo()
			},
			
			getMineInfo(){
				getMineData().then(res => {
					this.balance = res.withdrawableCommission || '0.00'
					return getWithdrawInfo()
				}).then(res => {
					this.account = res && res.alipayAccount ? res : {}
				}).catch(e => {
					if (!e.handled) {
						this.$toast('加载失败')
					}
				}).finally(() => {
					this.$toast.clear()
				})
			},
			setAmount(val) {
				this.amount = String(val)
			},
			handleWithdraw() {
				if (!this.account.realName || !this.account.alipayAccount) {
					this.$toast('请先设置账户信息')
					return
				}
				if (!this.amount.trim()) {
					this.$toast('请填写提现金额')
					return
				}
				const num = parseFloat(this.amount)
					const bal = parseFloat(this.balance)
					if (isNaN(num) || !/^\d+\.?\d{0,2}$/.test(this.amount.trim())) {
						this.$toast('请输入小数点后两位的有效金额')
						return
					}
				if (num <= 0) {
					this.$toast('提现金额必须大于0')
					return
				}
				if (num > bal) {
					this.$toast('提现金额不能超过可提现余额')
					return
				}
				this.$toast.loading({
					message: '提交中...',
					duration: 0
				})
				submitWithdrawApply({
					amount: num
				}).then(() => {
					this.$toast.clear()
						this.$toast({message:'提现申请已提交，请等待后台审核打款!',forbidClick: true,duration:0})
						this.amount = ''
						this.getMineInfo()
				}).catch(e => {
					this.$toast.clear()
					if (e.handled) return
					this.$toast(e.msg || '提现失败')
				})
			},
			goEdit() {
				this.formData = {
					name: this.account.realName || '',
					account: this.account.alipayAccount || ''
				}
				this.showEditModal = true
			},
			closeEditModal() {
				this.showEditModal = false
			},
			confirmEdit() {
				if (!this.formData.name.trim()) {
					this.$toast('请输入真实姓名')
					return
				}
				if (!this.formData.account.trim()) {
					this.$toast('请输入支付宝账号')
					return
				}
				this.$toast.loading({
					message: '保存中...',
					duration: 0
				})
				saveWithdrawAccount({
						realName: this.formData.name.trim(),
						alipayAccount: this.formData.account.trim()
					})
					.then(() => {
						this.$toast.clear()
						this.$toast('保存成功')
						this.showEditModal = false
						this.account = {
							realName: this.formData.name.trim(),
							alipayAccount: this.formData.account.trim()
						}
					})
					.catch(e => {
						this.$toast.clear()
						if (e.handled) return
						this.$toast(e.msg || '保存失败')
					})
			},

			goRecords() {
				this.$router.push('/records')
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.withdraw-page {
			padding: 14px 14px 0;

			.balance-card {
				padding: 20px 16px;
				background: #2FACFF;
				border-radius: 8px;

				.balance-settings {
					width: 100%;
					font-size: 15px;
					color: #fff;
				}

				.balance-cell {
					margin-top: 10px;
					color: #fff;
					font-size: 15px;

					.balance-label {
						flex: none;
						width: 100px;
						word-break: break-all;
					}

					.balance-value {
						flex: 1;
						word-break: break-all;
					}
				}
			}

			.section-title {
				margin-top: 20px;
				margin-bottom: 10px;
				color: #222222;
				font-size: 16px;
				font-weight: bold;
			}

			.amount-card {
				border-radius: 8px;
				padding: 20px 16px;

				.amount-input-box {
					border-bottom: 1px solid #e4e7ed;

					.amount-prefix {
						flex: none;
						color: #333;
						font-size: 24px;
						font-weight: bold;
						margin-right: 8px;
					}

					.amount-input {
						flex: 1;
						height: 40px;
						line-height: 40px;
						color: #333;
						font-weight: bold;
						font-size: 20px;
					}
				}

				.amount-tips {
					padding-top: 14px;
					color: #666;
					font-size: 13px;
					line-height: 1.5;

					.amount-money {
						font-weight: bold;
						color: #e62828;
					}

					.amount-all {
						color: #328ef1;
						cursor: pointer;
					}
				}
			}

			.withdraw-btn {
				height: 44px;
				line-height: 44px;
				margin-top: 20px;
				color: #333;
				text-align: center;
				background: #FFD904;
				border-radius: 8px;
				font-size: 16px;
				cursor: pointer;
				width: 100%;
			}

			.withdraw-record {
				color: #328ef1;
				font-size: 14px;
				text-align: center;
				margin-top: 14px;

				div {
					text-decoration: underline;
					cursor: pointer;
				}
			}

			.rules-card {
				word-break: break-all;
				font-size:13px;
				color:#999;
				line-height:1.5;

				:deep(img) {
					max-width: 100%;
					height: auto;
				}

				:deep(table) {
					width: 100%;
					max-width: 100%;
					border-collapse: collapse;
				}

				:deep(ol) {
					list-style-type: decimal;
				}

				:deep(ul) {
					list-style-type: disc;
				}
			}

			.edit-panel {
				.edit-header {
					flex: none;
					padding: 14px;
					border-bottom: 1px solid #e4e7ed;

					.edit-title {
						color: #222222;
						font-size: 15px;
						font-weight: bold;
					}

					.edit-close {
						font-size: 20px;
						color: #999999;
						cursor: pointer;
					}
				}

				.edit-body {
					padding: 0 14px 14px;

					.edit-field {
						padding-top: 14px;

						.edit-label {
							margin-bottom: 8px;
							color: #333;
							font-size: 14px;
						}

						.edit-input {
							width: 100%;
							height: 44px;
							line-height: 44px;
							padding: 0 12px;
							color: #222222;
							background: #f6f6f6;
							border-radius: 4px;
							font-size: 14px;
							box-sizing: border-box;
						}
					}
				}

				.edit-actions {
					padding: 14px;
					border-top: 1px solid #e4e7ed;

					.edit-submit {
						width: 100%;
						text-align: center;
						height: 40px;
						line-height: 40px;
						border-radius: 20px;
						font-size: 15px;
						cursor: pointer;
						color: #ffffff;
						background: #e33737;
					}
				}
			}
		}
	}
</style>